import React, {useEffect, useState} from "react";

const VkGroupWidget = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

  useEffect(() => {
    const initWidget = () => {
      if (!window.VK || !window.VK.Widgets) {
        return;
      }

      const container = document.getElementById("vk_groups");
      if (!container) {
        return;
      }

      container.innerHTML = "";
      window.VK.Widgets.Group(
        "vk_groups",
        {
          mode: 4,
          wide: 1,
          width: isMobile ? 360 : 560,
          height: isMobile ? 560 : 800,
          color1: "FFFFFF",
          color2: "000000",
          color3: "5181B8",
        },
        210252313
      );
    };

    initWidget();
    window.addEventListener("vk-openapi-ready", initWidget);

    return () => {
      window.removeEventListener("vk-openapi-ready", initWidget);
      const container = document.getElementById("vk_groups");
      if (container) {
        container.innerHTML = "";
      }
    };
  }, [isMobile]);
  return (
      <div className= "d-flex flex-column justify-content-between">
        <div className="text-center fs-2 font-bold">Сообщество ВКонтакте</div>
        <div id="vk_groups"></div>
      </div>
  );
};

export default VkGroupWidget;
